var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"stroke-current","strokeWidth":"1.5","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M1 6.913a5.913 5.913 0 1011.826 0A5.913 5.913 0 001 6.913zM11.094 11.094L18 18"})));
}

SearchInline.defaultProps = {"width":"19","height":"19"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
